import { makeStyles } from '@material-ui/styles'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'

export const Accordion = withStyles({
    root: {
        marginTop: 16,
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

export const AccordionSummary = withStyles({
    root: {
        borderRadius: '1px',
        backgroundColor: '#f0f2f5',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expandIcon: {
        fontSize: 14,
    },
    expanded: {},
})(MuiAccordionSummary)

export const AccordionDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails)

export const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: theme.colors.light.offWhite2,
        overflowY: 'scroll',
        padding: '36px 16px',
        transition: 'visibility 0s 1s, opacity 1s linear',
        height: '100%',
    },
    fadeOut: {
        visibility: 'hidden',
        opacity: 0,
    },
    heading: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        fontSize: 14,
        letterSpacing: 0.2,
        color: theme.colors.black,
        marginBottom: 12,
        textTransform: 'uppercase',
    },
    createAccountHeading: {
        marginTop: 24,
    },
    subheading: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 14,
        color: theme.colors.text.dark,
        lineHeight: 1.71,
        marginBottom: 8,
    },
    expansionSummary: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 14,
        ...theme.fontColors.darkGrey,
        lineHeight: 1.43,
        margin: 0,
    },
    signInLink: {
        ...theme.typographyPresets.bodySecondaryLight,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        cursor: 'pointer',
        textDecoration: 'underline',
        border: 0,
        background: 0,
        marginTop: 20,
    },
    code: {
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        fontSize: 36,
        letterSpacing: 'normal',
        color: theme.colors.black,
        marginBottom: 16,
    },
    subheadingBold: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        textDecoration: 'underline',
        fontSize: 14,
        color: theme.colors.text.dark,
        lineHeight: 1.71,
        marginBottom: 20,
    },
    close: {
        ...theme.modalClose,
    },
    authForm: {
        marginTop: 24,
    },
    authError: {
        ...theme.typographyPresets.bodySecondary,
        margin: '16px 0 32px 0',
        textAlign: 'center',
        width: '100%',
        color: 'red',
    },
    chevronRightIcon: {
        ...theme.fontColors.darkGrey,
    },
}))
